import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-losaprily-images-grid.js';

const IMAGE_1 = 'https://cdn.skyfastimg.com/images/2026/06/24/image-6a3baea4228b8b3f0fb995fb.jpg?w=500&h=50&q=80';
const IMAGE_2 = 'https://cdn.skyfastimg.com/images/2026/06/24/image-6a3baeb2ab2c2a0d1c8a0d74.jpg?w=500&h=50&q=80';
const IMAGE_3 = 'https://cdn.skyfastimg.com/images/2026/06/24/image-6a3baec073b03f68bb21d822.jpg?w=500&h=50&q=80';
const IMAGE_4 = 'https://cdn.skyfastimg.com/images/2026/06/24/image-6a3baed483bc6106bc6a3cee.jpg?w=500&h=50&q=80';
const IMAGE_5 = 'https://cdn.skyfastimg.com/images/2026/06/24/image-6a3baee3352940b08130a413.jpg?w=500&h=50&q=80';
const BOX_ICON = 'https://cdn.skyfastimg.com/images/2026/06/24/image-6a3baef91c1d2f20a93bc642.avif?w=100&h=50&q=80';

const contentHtml = `
  <div class="losaprily-images-grid container" data-attribute="losaprily-images-grid-content" data-container-full-width="false">
    <div class="losaprily-images-grid__top" data-attribute="losaprily-images-grid__top">
      <div class="losaprily-images-grid__item losaprily-images-grid__item--image-1">
        <img
          loading="lazy"
          data-attribute="losaprily-images-grid__image-1"
          src="${IMAGE_1}"
          alt=""
        />
      </div>
      <div
        class="losaprily-images-grid__item losaprily-images-grid__item--box"
        data-attribute="losaprily-images-grid__box"
        data-background="#ffffff"
        data-text-color="#000000"
        style="--box-bg: #ffffff; --box-text-color: #000000; --box-icon-size-desktop: 48px; --box-icon-size-mobile: 30px; background-color: #ffffff; color: #000000;"
      >
        <img
          loading="lazy"
          data-attribute="losaprily-images-grid__box-icon"
          data-icon-size-desktop="48"
          data-icon-size-mobile="30"
          data-icon-position="center"
          src="${BOX_ICON}"
          alt=""
        />
        <div data-attribute="losaprily-images-grid__box-text">
          <h2 style="text-align: center">
            <span
              style="
                background-color: rgb(255, 255, 255);
                color: rgb(0, 121, 235);
                font-size: 24px;
              "
              ><strong>Fun water game in every situation</strong></span
            >
          </h2>
          <p style="text-align: center">
            <span
              style="
                background-color: rgb(255, 255, 255);
                color: rgb(75, 85, 99);
                font-size: 16px;
              "
              >To splash – wherever you've been!</span
            >
          </p>
        </div>
      </div>
      <div class="losaprily-images-grid__item losaprily-images-grid__item--image-2">
        <img
          loading="lazy"
          data-attribute="losaprily-images-grid__image-2"
          src="${IMAGE_2}"
          alt=""
        />
      </div>
      <div class="losaprily-images-grid__item losaprily-images-grid__item--image-3">
        <img
          loading="lazy"
          data-attribute="losaprily-images-grid__image-3"
          src="${IMAGE_3}"
          alt=""
        />
      </div>
    </div>
    <div class="losaprily-images-grid__bottom" data-attribute="losaprily-images-grid__bottom">
      <div class="losaprily-images-grid__item losaprily-images-grid__item--image-4">
        <img
          loading="lazy"
          data-attribute="losaprily-images-grid__image-4"
          src="${IMAGE_4}"
          alt=""
        />
      </div>
      <div class="losaprily-images-grid__item losaprily-images-grid__item--image-5">
        <img
          loading="lazy"
          data-attribute="losaprily-images-grid__image-5"
          src="${IMAGE_5}"
          alt=""
        />
      </div>
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#dbf1ff',
  topPadding: true,
  bottomPadding: true,
});
